import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Location } from "@angular/common";
import { Router, NavigationEnd, ActivatedRoute} from "@angular/router"


@Component({
  selector: 'mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.css']
})
export class MobileNavComponent implements OnInit {

  public componentLoaded: string = "";
  public searchTerm: string = "";

  @Input() isMobileMenuOpen;
  @Output() toggleMobileMenu: EventEmitter<boolean>= new EventEmitter();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  onClick(){
    this.toggleMobileMenu.emit(!this.isMobileMenuOpen);
  }

  backClicked(){
    this.location.back();
  }

  goToSearch(){
    if(this.isMobileMenuOpen === true ){
      this.toggleMobileMenu.emit(false);
    }
    this.router.navigate(['searchResults']);
  }

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) route = route.firstChild;
        return route
      })
      .filter(route => {
        return route.outlet === 'primary'
      })
      .mergeMap(route => route.data)
      .subscribe((event) => {
        this.componentLoaded= event['title'];
      });

    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) route = route.firstChild;
        return route
      })
      .filter(route => {
        return route.outlet === 'primary'
      })
      .mergeMap(route => route.queryParams)
      .subscribe((event) => {
        this.searchTerm = event['search'];
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/mobile-nav/mobile-nav.component.ts